import React, { useCallback, useEffect } from 'react';
import { StyleSheet } from 'react-native';
import { Container } from '@mui/system';
import { useDispatch, useSelector } from 'react-redux';
import { updateUserConfig } from '../../redux/configuration/action';
import { publishableKeySelector, userConfigurationSelector, userPaymentMethodsSelector } from '../EsSettings/selector';
import { AccountBilling as AccountBillingComponent } from '../../components/AccountSettings';
import { IPaymentCard } from '../../types/global/generic.types';
import { deletePaymentMethod, getPaymentMethods, getPublishableKey } from '../../redux/payment/action';
import { isEmpty } from '../../utils/lodash';
import { isExpired } from '../../components/AccountSettings/AccountBilling';
import { AddCard } from '../../components/Payment/EmptyCardAddition';

const styles = StyleSheet.create({
    container: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
    },
});

const AccountBilling = () => {
    const configuration = useSelector(userConfigurationSelector);
    const paymentMethods = useSelector(userPaymentMethodsSelector);
    const { publishableKey } = useSelector(publishableKeySelector);
    const dispatch = useDispatch();
    const handleUpdatePreference = (payload: any) => {
        dispatch(
            updateUserConfig({
                payload,
            }),
        );
    };
    const handlegetUserPreference = useCallback(() => {
        dispatch(getPublishableKey({ source: 'stripe' }));
        dispatch(getPaymentMethods());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        handlegetUserPreference();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleDeleteCard = (card: IPaymentCard, isDefaultCard?: boolean) => {
        if (isDefaultCard && paymentMethods && paymentMethods?.length > 1) {
            /** Make the next card card default
             * TODO: Check if the current card is used in subscription and block the deletion
             */
            const nextAvailableCard = paymentMethods.find(
                c => c._id !== card._id && !isExpired(c.authorization.exp_month, c.authorization.exp_year),
            );
            if (nextAvailableCard) {
                handleUpdatePreference({
                    default_payment_method: nextAvailableCard._id,
                });
            }
            dispatch(
                deletePaymentMethod({
                    documentId: card._id,
                }),
            );
        } else {
            dispatch(
                deletePaymentMethod({
                    documentId: card._id,
                }),
            );
        }
    };

    return (
        <Container disableGutters style={styles.container} maxWidth={false}>
            {!!paymentMethods && !isEmpty(paymentMethods) && publishableKey && (
                <AccountBillingComponent
                    onChange={payload => handleUpdatePreference(payload)}
                    setting={configuration}
                    publicKey={publishableKey}
                    isNonUs={false} // Change this here
                    paymentMethods={paymentMethods}
                    onMakeDefault={card => {
                        handleUpdatePreference({
                            default_payment_method: card._id,
                        });
                    }}
                    onDeleteCard={handleDeleteCard}
                />
            )}
            {publishableKey && (!paymentMethods || isEmpty(paymentMethods)) && (
                <AddCard isNonUs={false} publicKey={publishableKey} amount={10} />
            )}
        </Container>
    );
};

export { AccountBilling };
